import React from 'react';
import DynamicField from '../DynamicField';
import CompositeField from '../CompositeField';

function FieldGroup({
  label,
  fields = [],
  derivedState = {},
  renderMode,
  renderType,
}) {
  const sortedFields = [...fields].sort((a, b) => a.sequence - b.sequence);

  const anyVisible = sortedFields.some(field => {
    const fs = derivedState[field.fieldKey];
    return !fs || fs.visible !== false;
  });

  if (!anyVisible) return null;

  const isComposite = label && sortedFields.length > 1;

  if (isComposite) {
    const description = sortedFields
      .map(f => f.description)
      .find(d => d && d.trim().length > 0) || '';

    return (
      <CompositeField
        groupLabel={label}
        fields={sortedFields}
        derivedState={derivedState}
        renderMode={renderMode}
        renderType={renderType}
        description={description}
      />
    );
  }

  return (
    <>
      {sortedFields.map(field => (
        <DynamicField
          key={field.fieldKey}
          config={field}
          fieldState={derivedState[field.fieldKey]}
          renderMode={renderMode}
          renderType={renderType}
        />
      ))}
    </>
  );
}

export default FieldGroup;
